import React, { useState, useEffect, useRef } from 'react';
import { translate } from '../../../Services/translation';
import { BCOrderHistoryRowNonBC } from '../BCOrderHistoryRowNonBC';
import { BCTabContainer } from './BCTabContainer';
import { useBCApi } from '../hooks/BCApi';
import { BCSpinner } from '../BCSpinner';
import { Pagination } from '../Pagination';

export const OrdersNonBC = () => {
  const [pageSize, setPageSize] = useState(5); // Default page size
  const totalOrders = useRef(0);
  const [orderHistory, setOrderHistory] = useState([]);
  const [backorders, setBackorders] = useState([]);
  const [generalError, setGeneralError] = useState('');
  const { status, value, error, execute } = useBCApi(
    '/api/order?convertToBusinessCentralOrder=true',
    true
  );

  useEffect(() => {
    if (status === 'success') {
      setOrderHistory(value.orders);
      totalOrders.current = value.totalCount;
    }
  }, [status, value]);

  const changePage = (page) => {
    execute('GET', {}, '&pageIndex=' + page);
  };

  return (
    <BCTabContainer title={translate('business.orderstab.header')}>
      <div className="OrdersTab__content">
        {backorders.length > 0 && (
          <>
            <h1 className="OrdersTab__content__title">
              {translate('business.orderstab.backorders')} {generalError}
            </h1>
            <div className="OrdersTab__content__backorders-table">
              <div className="OrdersTab__content__backorders-table__header">
                <p>{translate('business.orderstab.backorders.ordernr')}</p>
                <p>{translate('business.orderstab.backorders.item')}</p>
                <p>{translate('business.orderstab.backorders.price')}</p>
                <p>{translate('business.orderstab.backorders.ordered')}</p>
                <p>{translate('business.orderstab.backorders.delivered')}</p>
                <p>
                  {translate('business.orderstab.backorders.remaininglisted')}
                </p>
                <p>
                  {translate(
                    'business.orderstab.backorders.expecteddeliverydate'
                  )}
                </p>
              </div>
              {backorders.map((backorder, index) => (
                <div
                  key={index}
                  className="OrdersTab__content__backorders-table__row"
                >
                  <p>{backorder.ordernr}</p>
                  <p>{backorder.item}</p>
                  <p>{backorder.price}</p>
                  <p>{backorder.ordered}</p>
                  <p>{backorder.delivered}</p>
                  <p>{backorder.remainingListed}</p>
                  <p>{backorder.expectedDeliveryDate}</p>
                </div>
              ))}
            </div>
          </>
        )}

        <h1 className="OrdersTab__content__title">
          {translate('business.orderstab.orderhistory')}
        </h1>
        <div className="OrdersTab__content__orderhistory-table">
          <div className="OrdersTab__content__orderhistory-table__header">
            <p>{translate('business.orderstab.orderhistory.ordernr')}</p>
            <p>{translate('business.orderstab.orderhistory.date')}</p>
            <p>{translate('business.orderstab.orderhistory.price')}</p>
            <p>{translate('business.orderstab.orderhistory.contactperson')}</p>
            <p>{translate('business.orderstab.orderhistory.approved')}</p>
            <p>{translate('business.orderstab.orderhistory.status')}</p>
            <p></p>
          </div>
          <div className="OrdersTab__content__orderhistory-table__body">
            {status === 'pending' ? (
              <div className="OrdersTab__content__orderhistory-table__body__pending">
                <BCSpinner />
              </div>
            ) : (
              orderHistory.map((order, index) => (
                <BCOrderHistoryRowNonBC
                  key={index}
                  order={order}
                  setGeneralError={setGeneralError}
                />
              ))
            )}
          </div>
        </div>
      </div>
      <Pagination
        onChangePage={changePage}
        totalCount={totalOrders.current}
        pageSize={pageSize}
      />
    </BCTabContainer>
  );
};
